(() => {
  const featureConfigs = [
    {
      key: 'auctions',
      selector: '#_a-modal-group, #_a-starting-bid, [id*="auction-container"], [id^="shopify-block"][id*="auction"]',
      stylesheets: ['//www.bringts.ch/cdn/shop/t/28/assets/custom-auctions.css?v=83876905435608669471785028135'],
      scripts: ['//www.bringts.ch/cdn/shop/t/28/assets/custom-auctions.js?v=174359596718350402751788204008']
    },
    {
      key: 'bundles',
      selector: '.bndlr-bundle-listing-container, .bundler-target-element, .bundler-widgets-side-by-side',
      stylesheets: ['//www.bringts.ch/cdn/shop/t/28/assets/custom-bundle.css?v=107599346842436050801787162594'],
      scripts: ['//www.bringts.ch/cdn/shop/t/28/assets/custom-bundle.js?v=181119563348426854051787162594']
    },
    {
      key: 'pickup-availability',
      selector: 'pickup-availability-compact',
      stylesheets: [],
      scripts: ['//www.bringts.ch/cdn/shop/t/28/assets/component-pickup-availability.js?v=177086145694380957371785028135'],
      shouldLoad() {
        return typeof customElements.get('pickup-availability-compact') === 'undefined';
      }
    }
  ];

  function loadStylesheet(href) {
    if (document.querySelector(`link[data-feature-asset="${href}"]`)) {
      return;
    }
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.dataset.featureAsset = href;
    document.head.appendChild(link);
  }

  function loadScript(src) {
    if (document.querySelector(`script[data-feature-asset="${src}"]`)) {
      return;
    }
    const script = document.createElement('script');
    script.src = src;
    script.defer = true;
    script.dataset.featureAsset = src;
    document.head.appendChild(script);
  }

  function rootContainsFeature(root, selector) {
    if (root === document) {
      return Boolean(document.querySelector(selector));
    }
    if (!root || root.nodeType !== 1) {
      return false;
    }
    return root.matches(selector) || Boolean(root.querySelector(selector));
  }

  function tryLoadFeature(featureConfig, root) {
    if (featureConfig.loaded) {
      return;
    }

    const shouldLoad = featureConfig.shouldLoad ? featureConfig.shouldLoad() : true;
    if (!shouldLoad) {
      featureConfig.loaded = true;
      return;
    }

    if (!rootContainsFeature(root, featureConfig.selector)) {
      return;
    }

    featureConfig.loaded = true;
    featureConfig.stylesheets.forEach(loadStylesheet);
    featureConfig.scripts.forEach(loadScript);
  }

  function remainingFeatureCount() {
    return featureConfigs.filter((featureConfig) => !featureConfig.loaded).length;
  }

  function tryLoadFeatures(root = document) {
    featureConfigs.forEach((featureConfig) => {
      tryLoadFeature(featureConfig, root);
    });
    return remainingFeatureCount();
  }

  const remainingFeatures = tryLoadFeatures();
  if (!remainingFeatures || typeof MutationObserver === 'undefined') {
    return;
  }

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          tryLoadFeatures(node);
        }
      });
    });

    if (remainingFeatureCount() === 0) {
      observer.disconnect();
    }
  });

  observer.observe(document.body || document.documentElement, {
    childList: true,
    subtree: true
  });

  window.setTimeout(() => {
    observer.disconnect();
  }, 15000);
})();
